import axios from 'axios';
import querystring from 'qs';

const axiosGraphQL = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  // baseURL: "http://smar.kalendula.vn/graphql",
  // headers: { "X-Custom-Header": "foobar" },
  paramsSerializer: (params) => {
    return querystring.stringify(params, { arrayFormat: 'brackets' });
  },
});

axiosGraphQL.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');

  if (token) {
    (config as any).headers.Authorization = `Bearer ${token}`;
  }
  // (config as any).headers["x-private-key"] =
  //   process.env.REACT_APP_X_PRIVATE_KEY;
  // (config as any).headers["x-application-name"] =
  //   process.env.REACT_APP_X_APPLICATION_NAME;

  return config;
});

axiosGraphQL.interceptors.response.use((response) => {
  return response.data;
});

export default axiosGraphQL;
